import { createSlice } from "@reduxjs/toolkit";
import {
  addReplyMaterial,
  addImageReplyMaterial,
  updateReplyMaterial,
  deleteReplyMaterial,
  fetchTextReply,
  fetchImageReply,
  fetchDocumentReply,
  fetchReplyMaterial,
  fetchTemplateReply,
  addDocumentReplyMaterial,
  fetchChatbotReply,
  addVideoReplyMaterial,
  fetchVideoReply,
  fetchStickerReply,
  addStickerReply,
  deleteStickerReply,
  importStickerReply,
} from "./ReplyMaterialThunk.js";

const initialState = {
  replyMaterial: [],
  textReplyMaterial: [],
  imageReplyMaterial: [],
  documentReplyMaterial: [],
  videoReplyMaterial: [],
  templateReplyMaterial: [],
  chatbotReplyMaterial: [],
  stickerReplyMaterial: [],
  loading: false,
  error: null,
};

const replyMaterialSlice = createSlice({
  name: "replyMaterial",
  initialState,
  reducers: {
    setReplyMaterial: (state, action) => {
      state.replyMaterial = action.payload;
    },
    clearReplyMaterial: (state) => {
      state.replyMaterial = [];
      state.textReplyMaterial = [];
      state.imageReplyMaterial = [];
      state.documentReplyMaterial = [];
      state.videoReplyMaterial = [];
      state.templateReplyMaterial = [];
      state.chatbotReplyMaterial = [];
      state.stickerReplyMaterial = [];
      state.loading = true;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // fetch chatbotReply
    builder.addCase(fetchChatbotReply.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(fetchChatbotReply.fulfilled, (state, action) => {
      state.loading = false;
      state.chatbotReplyMaterial = action.payload;
    });

    builder.addCase(fetchChatbotReply.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //fetch templateReply

    builder.addCase(fetchTemplateReply.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(fetchTemplateReply.fulfilled, (state, action) => {
      state.loading = false;
      state.templateReplyMaterial = action.payload;
    });

    builder.addCase(fetchTemplateReply.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // fetch ReplyMaterial
    builder.addCase(fetchReplyMaterial.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(fetchReplyMaterial.fulfilled, (state, action) => {
      state.loading = false;
      state.replyMaterial = action.payload;
    });

    builder.addCase(fetchReplyMaterial.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //fetch text reply
    builder.addCase(fetchTextReply.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchTextReply.fulfilled, (state, action) => {
      state.loading = false;
      state.textReplyMaterial = action.payload;
    });
    builder.addCase(fetchTextReply.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // fetch image reply
    builder.addCase(fetchImageReply.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchImageReply.fulfilled, (state, action) => {
      state.loading = false;
      state.imageReplyMaterial = action.payload;
    });
    builder.addCase(fetchImageReply.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // fetch document reply
    builder.addCase(fetchDocumentReply.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchDocumentReply.fulfilled, (state, action) => {
      state.loading = false;
      state.documentReplyMaterial = action.payload;
    });
    builder.addCase(fetchDocumentReply.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // fetch video reply
    builder.addCase(fetchVideoReply.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchVideoReply.fulfilled, (state, action) => {
      state.loading = false;
      state.videoReplyMaterial = action.payload;
    });
    builder.addCase(fetchVideoReply.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Add
    builder.addCase(addReplyMaterial.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(addReplyMaterial.fulfilled, (state, action) => {
      state.loading = false;
      state.replyMaterial.push(action.payload);
    });
    builder.addCase(addReplyMaterial.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Add Image
    builder.addCase(addImageReplyMaterial.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(addImageReplyMaterial.fulfilled, (state, action) => {
      state.loading = false;
      state.replyMaterial.push(action.payload);
      state.imageReplyMaterial.push(action.payload);
    });
    builder.addCase(addImageReplyMaterial.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Add Document
    builder.addCase(addDocumentReplyMaterial.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(addDocumentReplyMaterial.fulfilled, (state, action) => {
      state.loading = false;
      state.replyMaterial.push(action.payload);
      state.documentReplyMaterial.push(action.payload);
    });
    builder.addCase(addDocumentReplyMaterial.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Add Video
    builder.addCase(addVideoReplyMaterial.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(addVideoReplyMaterial.fulfilled, (state, action) => {
      state.loading = false;
      state.replyMaterial.push(action.payload);
      state.videoReplyMaterial.push(action.payload);
    });
    builder.addCase(addVideoReplyMaterial.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Update
    builder.addCase(updateReplyMaterial.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateReplyMaterial.fulfilled, (state, action) => {
      state.loading = false;
      const index = state.replyMaterial.findIndex(
        (item) => item._id === action.payload._id
      );
      if (index !== -1) {
        state.replyMaterial[index] = action.payload;
      }

      const imageIndex = state.imageReplyMaterial.findIndex(
        (item) => item._id === action.payload._id
      );
      if (imageIndex !== -1) {
        state.imageReplyMaterial[imageIndex] = action.payload;
      }

      const docIndex = state.documentReplyMaterial.findIndex(
        (item) => item._id === action.payload._id
      );
      if (docIndex !== -1) {
        state.documentReplyMaterial[docIndex] = action.payload;
      }

      const videoIndex = state.videoReplyMaterial.findIndex(
        (item) => item._id === action.payload._id
      );
      if (videoIndex !== -1) {
        state.videoReplyMaterial[videoIndex] = action.payload;
      }
    });
    builder.addCase(updateReplyMaterial.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Delete
    builder.addCase(deleteReplyMaterial.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteReplyMaterial.fulfilled, (state, action) => {
      state.loading = false;
      const deletedId = action.payload;
      state.replyMaterial = state.replyMaterial.filter(
        (item) => item._id !== deletedId
      );
      state.imageReplyMaterial = state.imageReplyMaterial.filter(
        (item) => item._id !== deletedId
      );
      state.documentReplyMaterial = state.documentReplyMaterial.filter(
        (item) => item._id !== deletedId
      );
      state.videoReplyMaterial = state.videoReplyMaterial.filter(
        (item) => item._id !== deletedId
      );
    });
    builder.addCase(deleteReplyMaterial.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // fetch sticker reply
    builder.addCase(fetchStickerReply.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchStickerReply.fulfilled, (state, action) => {
      state.loading = false;
      state.stickerReplyMaterial = action.payload;
    });
    builder.addCase(fetchStickerReply.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    // add sticker
    builder.addCase(addStickerReply.fulfilled, (state, action) => {
      state.stickerReplyMaterial.unshift(action.payload);
      state.loading = false;
    });
    builder.addCase(addStickerReply.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addStickerReply.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // delete sticker
    builder.addCase(deleteStickerReply.fulfilled, (state, action) => {
      const deletedId = action.payload;
      state.stickerReplyMaterial = state.stickerReplyMaterial.filter(
        (s) => s.content?.cloudinaryId !== deletedId && s._id !== deletedId
      );
      state.loading = false;
    });
    builder.addCase(deleteStickerReply.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteStickerReply.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // import sticker
    builder.addCase(importStickerReply.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(importStickerReply.fulfilled, (state, action) => {
      state.loading = false;
      const newSticker = action.payload;
      // Remove the common version (no _id) if it exists with same cloudinaryId
      state.stickerReplyMaterial = state.stickerReplyMaterial.filter(
        (s) =>
          !(
            s.content?.cloudinaryId === newSticker.content?.cloudinaryId &&
            !s._id
          )
      );
      // Add the new project version
      state.stickerReplyMaterial.unshift(newSticker);
      // Also add it to generic replyMaterial for selection chips
      state.replyMaterial.push(newSticker);
    });
    builder.addCase(importStickerReply.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { setReplyMaterial, clearReplyMaterial } =
  replyMaterialSlice.actions;
export default replyMaterialSlice.reducer;
